module.exports = __webpack_public_path__ + "img/pied-dathlète.6d11bef1.jpg";